module.exports = __webpack_public_path__ + "static/img/ltlogo.9b4973c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ltlogo.png
// module id = 5oDG
// module chunks = 15